/* @flow */
export default {
  Highest: 1000,
  Higher: 900,
  High: 800,
  Low: 700,
  Lower: 600,
  Lowest: 500,
};



// WEBPACK FOOTER //
// ./src/ui/constants/ZIndex.js